import Lookup from 'src/componentes/select-async';
import PesquisaClimaListView from 'src/paginas/avaliacao-desempenho/PesquisaClima/PesquisaClimaListView';

const PesquisaClimaLookup = ({ ...rest }) => (
  <Lookup
    labelKey="nome"
    valueKey="id"
    url="/PesquisaClimaLookup"
    showSearch
    showNew={false}
    clearable
    showModal
    searchComponent={PesquisaClimaListView}
    {...rest}
  />
);

export default PesquisaClimaLookup;